import { Button, CommonGlobalService, CrossIcon, DownloadButton, FileIcon, FileImgIcon, FilePdfIcon, FileTxtIcon, FileType } from '@umanforge/common';
import { FmDocSearch } from 'interfaces/api_deep_search.interfaces';
import React, { useEffect, useState } from 'react';
import { BaseCardComponent } from '../baseCard.component';

interface FmDocCardProps {
  doc: FmDocSearch;
}

const FmDocCardComponent: React.FC<FmDocCardProps> = ( { doc } ) => {

  const [ fileIcon, setFileIcon ] = useState<JSX.Element>( <></> );
  const [ fileViewer, setFileViewer ] = useState<JSX.Element | null>( null );
  const [ isOpen, setIsOpen ] = useState<boolean>( false );

  useEffect( () => {
    if ( isOpen ) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [ isOpen ] );

  useEffect( () => {
    updateFileIcon();
  }, [ doc ] );

  const openPopup = () => {
    if ( doc.path != null && doc.path != '' ) {
      setIsOpen( true );
    }
  };

  const closePopup = () => {
    setIsOpen( false );
  };

  const updateFileIcon = () => {
    switch ( CommonGlobalService.getFileType( doc.path ) ) {
    case FileType.IMAGE:
      setFileViewer(
        <img
          src={ doc.path }
          className='w-full h-full max-h-[90vh] max-w-[90vw]'
        />
      );
      setFileIcon(
        <img
          src={ doc.path }
          className='w-full h-full object-cover'
          onError={ () => {
            setFileViewer( null );
            setFileIcon( <FileImgIcon className='w-full h-full'/> );
          } }
        />
      );
      break;
    case FileType.PDF:
      setFileViewer( null );
      setFileIcon( <FilePdfIcon className='w-full h-full'/> );
      break;
    case FileType.TEXT:
      setFileViewer( null );
      setFileIcon( <FileTxtIcon className='w-full h-full'/> );
      break;
    default:
      setFileViewer( null );
      setFileIcon( <FileIcon className='w-full h-full'/> );
      break;
    }
  };

  return (
    <>
      <BaseCardComponent
        id={ String( doc.index ) }
        title={ doc.eventTitle }
        breadcrumb={ `${ doc.clientName } / ${ doc.siteName } / ${ doc.sectorName } / ${ doc.eventManagerName }` }
        application={ doc.application }
        firstChildren={
          <div className='flex w-full h-full gap-3 items-center'>
            <DownloadButton fileInfo={{ name: doc.name, url: doc.path }}/>
            <span className='italic text-sm text-gray-900 underline' >
              { doc.name }
            </span>
          </div>
        }
        secondeChildren={
          <div className='flex h-full w-fit p-2 items-center justify-center'>
            <div
              className={ `h-20 w-20 rounded-md overflow-hidden ${ fileViewer ? 'cursor-pointer' : '' }`}
              onClick={ () => {
                if ( fileViewer ) {
                  openPopup();
                }
              } }
            >
              { fileIcon }
            </div>
          </div>
        }
      />
      {
        ( isOpen && fileViewer ) ?
          <div className="fixed inset-0 flex items-center justify-center z-[100]">
            <div className="absolute inset-0 appear bg-gray-800 rounded-t-[11px] rounded-b-[6px]" />
            <div className='absolute flex w-full h-full p-2 items-center justify-center'>
              <div className='flex flex-col rounded-md bg-white-base overflow-hidden'>
                <div className='flex w-full justify-between items-center'>
                  <div className='flex w-full gap-3 px-3' >
                    <DownloadButton fileInfo={{ name: doc.name, url: doc.path }}/>
                    <span className='italic text-lg underline line-clamp-1' >
                      { doc.name }
                    </span>
                  </div>
                  <Button
                    icon={
                      <CrossIcon className="w-7 h-7 group-hover:rotate-[360deg] transition-transform duration-700"/>
                    }
                    className='bg-transparent hover:bg-red-200 hover:text-red-base hover:border-transparent text-xl shadow-none'
                    onClick={ () => { closePopup(); } }
                  />
                </div>
                { fileViewer }
              </div>
            </div>
          </div>
          :
          null
      }
    </>
  );
};

export { FmDocCardComponent };